import React from 'react'

import { ScrollView, StyleSheet, Text } from 'react-native'

import { adaptive, colors } from '@sart/styles'

export default function LegalItem(props) {
  const { route } = props
  const item = route.params?.item
  return (
    <ScrollView style={styles.wrapper}>
        <Text>{item.content}</Text>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
  }
})
